type KeyValue = { Key: string; Value: any };

export interface Experience {
  company: string;
  title: string;
  location?: string;
  duration?: string;
  description?: string;
  start_year?: number;
  end_year?: number;
  [key: string]: any;
}

export interface Education {
  school: string;
  degree: string;
  field_of_study?: string;
  start_year?: number;
  end_year?: number;
  [key: string]: any;
}

export interface Profile {
  full_name?: string;
  headline?: string;
  about?: string;
  experiences?: Experience[];
  educations?: Education[];
  languages?: { name: string; proficiency: string }[];
  [key: string]: any;
}

export function formatProfileData(rawData: any): Profile {
  if (!rawData) return {};
  if (typeof rawData === "string") {
    try {
      rawData = JSON.parse(rawData);
    } catch {
      console.error("Invalid JSON passed to formatProfileData");
      return {};
    }
  }

  if (!Array.isArray(rawData)) {
    console.error("Expected array input, got:", typeof rawData);
    return {};
  }

  const profile: Record<string, any> = {};

  for (const { Key, Value } of rawData) {
    if (!Key) continue;

    if (Array.isArray(Value)) {
      const list = Value.flatMap((inner) => {
        if (Array.isArray(inner)) {
          return inner.reduce((acc: Record<string, any>, kv: KeyValue) => {
            if (kv?.Key) acc[kv.Key] = kv.Value;
            return acc;
          }, {});
        }
        return [];
      });

      if (["experiences", "educations", "languages"].includes(Key)) {
        profile[Key] = list;
      } else {
        profile[Key] = list;
      }
    } else {
      profile[Key] = Value;
    }
  }

  profile.experiences = profile.experiences || [];
  profile.educations = profile.educations || [];
  profile.languages = profile.languages || [];

  return profile as Profile;
}
